import React from 'react';

const ErrorElement = ({message, display, id}: { message: string; display: boolean; id?: string}) => {
    return (
        <>
            { display && (
                <div id={id} className="ontario-error-messaging" role="alert">
                    <span className="ontario-error-messaging__icon">
                        <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                        <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </span>
                    <span role="alert" id="text-input-odometer-example-error-text" className="ontario-error-messaging__content">
                        {message}
                    </span>
                </div>
            )}
        </>
    )
};

export default ErrorElement;